import React, {useState} from 'react'
import {
    HeroContainer,
    HeroBg,
    VideoBg,
    HeroContent,
    HeroH1,
    HeroP,
    HeroBtnWrapper,
    ArrowForward,
    ArrowRight
} from './heroElements'
import { Button } from './ButtonElement'
import Video from '../video/video.mp4'



const Herosection = ({ t }) => {
    const [hover,setHover]= useState(false)
    const onHover = () =>{
        setHover(!hover)
    }
    return (
        <HeroContainer>
            <HeroBg>
                <VideoBg autoPlay loop muted playsinline src={Video} type='video/mp4'/>
            </HeroBg>
            <HeroContent>
                <HeroH1>{t.hero.title}</HeroH1>
                <HeroP>
                   
                </HeroP>
                <HeroBtnWrapper>
                <Button  
                to="intro" 
                onMouseEnter={onHover} 
                onMouseLeave={onHover}
                primary='true'
                dark='true'
                siteBtn='true'
                offset={-80}
                >
                {t.hero.cta}
                {hover ? <ArrowForward /> : <ArrowRight/>}
                </Button>
                </HeroBtnWrapper>
            </HeroContent>
            
            
        </HeroContainer>
    )
}

export default Herosection;
